import { render, staticRenderFns } from "./RecAdmin.vue?vue&type=template&id=36e0f0b2&scoped=true"
import script from "./RecAdmin.vue?vue&type=script&lang=js"
export * from "./RecAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0f0b2",
  null
  
)

export default component.exports